import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Krachttraining: de feiten en fabels op een rij</title>
                <link rel="canonical" href={route("blogs.sixty-five")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Ah, krachttraining. Voor sommigen is het een dagelijkse routine, vergelijkbaar met tandenpoetsen maar dan met iets meer zweet. Voor anderen blijft het een mysterieus gebied, bevolkt door spierbundels en gewichten die meer lijken te wegen dan hun eigen lichaam. Maar wat is nu echt waar over krachttraining? En wat kunnen we gerust naar het rijk der fabelen verwijzen? Laten we, gewapend met wetenschappelijke artikelen (netjes genoteerd in APA stijl, want we houden het graag chic), deze wereld eens onder de loep nemen."
                />
                <meta
                    property="og:description"
                    content="Ah, krachttraining. Voor sommigen is het een dagelijkse routine, vergelijkbaar met tandenpoetsen maar dan met iets meer zweet. Voor anderen blijft het een mysterieus gebied, bevolkt door spierbundels en gewichten die meer lijken te wegen dan hun eigen lichaam. Maar wat is nu echt waar over krachttraining? En wat kunnen we gerust naar het rijk der fabelen verwijzen? Laten we, gewapend met wetenschappelijke artikelen (netjes genoteerd in APA stijl, want we houden het graag chic), deze wereld eens onder de loep nemen."
                />
                <meta property="og:url" content={route("blogs.sixty-five")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Krachttraining: de feiten en fabels op een rij - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/krachttraining-feiten-fabels.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/krachttraining-feiten-fabels.webp"
                                    type="image/webp"
                                    alt="Krachttrraining"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/krachttraining-feiten-fabels.jpg"
                                    type="image/png"
                                    alt="Krachttrraining"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/krachttraining-feiten-fabels.jpg"
                                    alt="Krachttrraining"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Krachttraining: de feiten en fabels op een rij
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Ah, krachttraining. Voor sommigen is het een dagelijkse
                        routine, vergelijkbaar met tandenpoetsen maar dan met
                        iets meer zweet. Voor anderen blijft het een mysterieus
                        gebied, bevolkt door spierbundels en gewichten die meer
                        lijken te wegen dan hun eigen lichaam. Maar wat is nu
                        echt waar over krachttraining? En wat kunnen we gerust
                        naar het rijk der fabelen verwijzen? Laten we, gewapend
                        met wetenschappelijke artikelen (netjes genoteerd in APA
                        stijl, want we houden het graag chic), deze wereld eens
                        onder de loep nemen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Feit of fabel: "Van krachttraining word je log en traag"
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Dit is een klassieker. Het idee dat je van{" "}
                        <a
                            href={route("blogs.thirty-nine")}
                            className="text-we-are-yellow"
                            target="_blank"
                        >
                            krachttraining
                        </a>{" "}
                        transformeert in een soort langzame, logge reus.
                        Wetenschappelijk onderzoek (ja, dat lezen we echt) laat
                        echter zien dat krachttraining, mits correct uitgevoerd,
                        je niet alleen sterker maar ook sneller kan maken. Het
                        verbetert de efficiëntie van de neuromusculaire
                        coördinatie, oftewel de samenwerking tussen je hersenen
                        en spieren. Dus, tenzij je training bestaat uit het
                        verplaatsen van je koelkast naar verschillende kamers in
                        je huis (niet aanbevolen), is deze fabel naar de eeuwige
                        jachtvelden.
                    </p>
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Feit of fabel: "Krachttraining is niet goed voor je
                        hart"
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Laten we dit eens voor altijd uit de wereld helpen:
                        krachttraining is juist goed voor je hart! Onderzoek
                        toont aan dat regelmatige krachttraining kan leiden tot
                        een lagere bloeddruk, verbeterde cholesterolwaarden en
                        een vermindering van het risico op hartziekten. Je hart
                        is ook een spier, vergeet dat niet. Dus in plaats van je
                        hart te breken met slechte levenskeuzes, kun je het
                        beter versterken met wat goede oude krachttraining.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Feit of fabel: "Krachttraining is alleen voor jonge
                        mensen"
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Deze fabel is zo hardnekkig dat zelfs sommige jonge
                        mensen geloven dat ze te 'oud' zijn om te beginnen met
                        krachttraining. De wetenschap zegt echter iets heel
                        anders. Onderzoek wijst uit dat krachttraining voordelen
                        heeft voor mensen van alle leeftijden, inclusief
                        verbeterde{" "}
                        <a
                            href={route("blogs.thirty-six")}
                            className="text-we-are-yellow"
                            target="_blank"
                        >
                            spiermassa
                        </a>
                        , sterkere botten en een betere balans. Dus of je nu 18
                        of 80 bent, het is nooit te laat (of te vroeg) om te
                        beginnen met het oppakken van die gewichten. Denk eraan,
                        de enige 'gewichten' die je niet moet oppakken, zijn de
                        vooroordelen.
                    </p>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Feit of fabel: "Krachttraining is niet voor vrouwen"
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Oh, deze oude kastanje. De mythe dat vrouwen van
                        krachttraining 'te gespierd' worden, is ongeveer even
                        waar als het idee dat de aarde plat is. Vrouwen hebben
                        van nature minder testosteron dan mannen, wat betekent
                        dat het voor hen moeilijker is om grote spiermassa op te
                        bouwen. Wat krachttraining wél doet, is helpen bij het
                        opbouwen van sterke, gezonde spieren, het verbranden van
                        vet en het verbeteren van de algehele gezondheid. Dus
                        dames, laat die gewichten niet links liggen.
                    </p>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Feit of fabel: "Je moet elke dag trainen om resultaten
                        te zien"
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Als dit waar was, zouden we allemaal ofwel in de
                        sportschool wonen ofwel ons abonnement opzeggen na de
                        eerste week. Gelukkig is het complete onzin.
                        Wetenschappelijk onderzoek toont aan dat voor de meeste
                        mensen drie tot vier keer per week krachttraining
                        volstaat om significante verbeteringen te zien. Het is
                        ook belangrijk om je spieren{" "}
                        <a
                            href={route("blogs.eleventh")}
                            className="text-we-are-yellow"
                            target="_blank"
                        >
                            rust te geven
                        </a>{" "}
                        en te herstellen. Dus als je dacht dat je geen excuus
                        had om die nieuwe Netflix-serie te bingewatchen op je
                        rustdagen, denk dan nog eens goed na.
                    </p>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Conclusie
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Krachttraining is omgeven door mythes en misverstanden,
                        maar hopelijk hebben we nu wat duidelijkheid kunnen
                        scheppen. Of je nu jong of oud bent, man of vrouw, het
                        toevoegen van krachttraining aan je routine kan
                        aanzienlijke voordelen hebben voor je gezondheid en
                        welzijn. Dus, pak die gewichten (of begin met
                        lichaamsgewichtoefeningen, we oordelen niet) en begin
                        aan je reis naar een sterker, gezonder jij. En onthoud:
                        de enige 'zware' beslissing die je moet nemen, is welke
                        oefening je als eerste doet.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
